import React, { ReactNode, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { garantias, listaGarantias } from '../../models/garantias';
import { useGarantias } from '../../hooks/useGarantias';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosResponse } from 'axios';
import { postTipoGarantia, putTipoGarantia } from '../../services/servicesGarantias';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import { useToast } from '../../../../hooks/useToast';
import { selectorTransversal } from '../../../../dtos/selector';
import { Dialog, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import CustomTooltip from '../../../../components/ui/materialui/customToolTip';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import InputSwitch from '../../../../components/inputs/yup/materialui/inputSwitch';
import ErrorIcon from '@mui/icons-material/Error';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface FormProps {
    idMutuo: number;
    children?: ReactNode;
    listaGarantias: listaGarantias[];
    defaultValues: garantias | undefined;
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    onHide: () => void
    esNuevo: boolean;
    renderizar: () => Promise<void>
    hipotecas: selectorTransversal[];
    listEstadoBienRaiz: selectorTransversal[];
    isComplementario: boolean;
    isDesactivado?: boolean;
    esVigente?: boolean;
}

const DatosGarantiaForm: React.FC<FormProps> = ({
    listaGarantias,
    idMutuo,
    defaultValues,
    show,
    onHide,
    esNuevo,
    renderizar,
    hipotecas,
    listEstadoBienRaiz,
    isComplementario,
    isDesactivado,
    esVigente
}) => {
    const { listaTipoConstruccion, listaTipoBienRaiz, listarInstitucionFinanciera, listTipoConstruccion, listTipoBienRaiz, listInstitucionFinan } = useGarantias();
    const { addToast } = useToast();
    const schema = Yup.object<garantias>().shape({
        idGarantias: Yup.number().optional(),
        tipoHipoteca: Yup.string().required("Campo requerido"),
        estadoBienRaiz: Yup.string().required("Campo requerido"),
        fechaTasacion: Yup.date().required("Campo requerido"),
        empresaTasadora: Yup.string().required("Campo requerido"),
        tipoConstruccion: Yup.string().required("Campo requerido"),
        añoConstruccion: Yup.number().required("Campo requerido"),
        tipoBienRaiz: Yup.string().required("Campo requerido"),
        descripcionGarantia: Yup.string().nonNullable().required("Campo requerido").test({
            name: 'valida-rut-distinto-deudor',
            exclusive: false,
            params: {},
            message: 'El tipo bien raíz y la descripción garantía, ya se encuentran asociado',
            test: async (value, context) => {

                if (listaGarantias.some(x =>
                    x.descripcionGarantia.trim().localeCompare(value.trim(), undefined, { sensitivity: 'base' }) === 0 &&
                    x.tipoBienRaizCodigo === context.parent.tipoBienRaiz &&
                    x.idGarantias !== context.parent.idGarantias
                )) {
                    return false;
                }

                return true;
            }
        }),
        valorGarantia: Yup.number().required("Campo requerido"),
        valorLiquidacion: Yup.number().required("Campo requerido"),
        m2Construidos: Yup.number().required("Campo requerido"),
        m2Terreno: Yup.number().required("Campo requerido"),
        montoCredito: Yup.number().optional(),
        pagaIva: Yup.boolean().required("Campo requerido"),
        tieneHipoteca: Yup.boolean().required("Campo requerido"),
        rutInstitucionFinanciera: Yup.string().nullable().when(['tieneHipoteca'], {
            is: (tieneHipoteca: boolean) => tieneHipoteca,
            then: s => s.required('Campo requerido'),
            otherwise: s => s.notRequired()
        }),

    });

    console.log('esnuevo', esNuevo);

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const {
        formState: { errors, isValid, isDirty },
        handleSubmit,
        reset,
        control,
        setValue,
        trigger,
        watch
    } = useForm<garantias>({
        defaultValues: defaultValues,
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const { tieneHipoteca } = watch();
    const currentYear: number = new Date().getFullYear();

    useEffect(() => {
        reset();
        reset(defaultValues);

        if (listaGarantias.length > 0 && esNuevo) {
            setValue('tipoHipoteca', listaGarantias[0].estadoBienRaizCodigo);
            setValue('estadoBienRaiz', listaGarantias[0].estadoBienRaizCodigo);
        }

    }, [reset, defaultValues, show]);

    useEffect(() => {
        listaTipoConstruccion();
        listaTipoBienRaiz();
        listarInstitucionFinanciera();
    }, []);

    useEffect(() => {
        if (show)
            trigger();
    }, [show])

    useEffect(() => {
        if (!tieneHipoteca) {
            setValue('rutInstitucionFinanciera', null);
        } else {
            trigger('rutInstitucionFinanciera');
        }

    }, [tieneHipoteca])

    const handleCalculoLiquidacion = (valorGarantia: number | null) => {
        if (valorGarantia && valorGarantia !== 0) {
            const valor: number = 0.8;
            setValue('valorLiquidacion', valor * valorGarantia);
        } else if (!valorGarantia || valorGarantia === 0) {
            setValue('valorLiquidacion', 0)
        }
    }

    const handleCancelar = () => {
        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: !esNuevo ?
                    "¿Desea abandonar la edición?" :
                    '¿Desea abandonar el ingreso?',
                metodo: () => {
                    onHide();
                    reset();
                },
            });
        }
        else {
            onHide();
            reset();
        }
    }

    const onSubmit = async (data: garantias) => {
        data.idMutuo = idMutuo;
        const response: AxiosResponse = !esNuevo ?
            await putTipoGarantia(data) : await postTipoGarantia(data);

        if (response.status === StatusCode.NoContent || response.status === StatusCode.Created || response.status === StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: !esNuevo ?
                    'Datos modificados correctamente' :
                    'Datos guardados correctamente'
            });
            renderizar();
            onHide();
        }
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />

            <Dialog
                open={show}
                onClose={onHide}
                maxWidth='lg'
            >
                <DialogTitle>
                    Tipo garantía
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid2 container spacing={2} sx={{ mt: 2 }}>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label="Tipo bien raíz"
                                    name="tipoBienRaiz"
                                    control={control}
                                    options={listTipoBienRaiz}
                                    error={errors.tipoBienRaiz}
                                    disabled={!esNuevo || isDesactivado || !esNuevo}
                                />

                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label={
                                        <>
                                            Tipo hipoteca{" "}
                                            <CustomTooltip text="Este cambio afectará a todas las garantías.">
                                                <ErrorIcon />
                                            </CustomTooltip>
                                        </>
                                    }
                                    name={'tipoHipoteca'}
                                    control={control}
                                    options={hipotecas}
                                    error={errors.tipoHipoteca}
                                    disabled={isComplementario || isDesactivado }
                                ></InputSelect>

                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label={
                                        <>
                                            Estado bien raíz{" "}
                                            <CustomTooltip text="Este cambio afectará a todas las garantías.">
                                                <ErrorIcon />
                                            </CustomTooltip>
                                        </>
                                    }
                                    name={'estadoBienRaiz'}
                                    control={control}
                                    options={listEstadoBienRaiz}
                                    error={errors.estadoBienRaiz}
                                    disabled={isComplementario || isDesactivado }
                                ></InputSelect>
                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputFecha
                                    label="Fecha tasación"
                                    name="fechaTasacion"
                                    control={control}
                                    fecha={defaultValues?.fechaTasacion ?? undefined}
                                    error={errors.fechaTasacion}
                                    esReadOnly={isComplementario}
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputText
                                    label="Empresa tasadora"
                                    name="empresaTasadora"
                                    control={control}
                                    error={errors.empresaTasadora}
                                    desabilitado={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label="Tipo construcción"
                                    name="tipoConstruccion"
                                    control={control}
                                    options={listTipoConstruccion}
                                    error={errors.tipoConstruccion}
                                    readonly={isComplementario}
                                    disabled={isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Año construcción"
                                    name="añoConstruccion"
                                    control={control}
                                    error={errors.añoConstruccion}
                                    presicion={4}
                                    maxValue={currentYear}
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputText
                                    label="Descripción garantía"
                                    name="descripcionGarantia"
                                    control={control}
                                    error={errors.descripcionGarantia}
                                    desabilitado={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Valor garantía"
                                    name="valorGarantia"
                                    control={control}
                                    error={errors.valorGarantia}
                                    decimales={4}
                                    esMoneda
                                    maxValue={1000000000}
                                    minValue={0}
                                    onChange={(value) => handleCalculoLiquidacion(value)}
                                    prefix='UF'
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Valor liquidación"
                                    name="valorLiquidacion"
                                    control={control}
                                    error={errors.valorLiquidacion}
                                    decimales={4}
                                    readonly
                                    maxValue={1000000000}
                                    minValue={0}
                                    esMoneda
                                    prefix='UF'
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="M2 construidos"
                                    name="m2Construidos"
                                    control={control}
                                    error={errors.m2Construidos}
                                    decimales={4}
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="M2 terreno"
                                    name="m2Terreno"
                                    control={control}
                                    error={errors.m2Terreno}
                                    decimales={4}
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }} sx={{ mt: tieneHipoteca ? 3 : 0 }}>
                                <InputSwitch
                                    label="Tiene hipoteca"
                                    name="tieneHipoteca"
                                    control={control}
                                    error={errors.tieneHipoteca}
                                    disabled={isComplementario || isDesactivado }
                                />
                            </Grid2>

                            {tieneHipoteca && (
                                <Grid2 size={{ xs: 12, lg: 3 }}>
                                    <InputSelect
                                        label="Institución financiera"
                                        name="rutInstitucionFinanciera"
                                        control={control}
                                        options={listInstitucionFinan}
                                        error={errors.rutInstitucionFinanciera}
                                        disabled={isComplementario || isDesactivado }
                                    />
                                </Grid2>
                            )}

                            <Grid2 size={{ xs: 12, lg: 3 }} sx={{ mt: tieneHipoteca ? 3 : 0 }}>
                                <InputSwitch
                                    label="Paga IVA"
                                    name="pagaIva"
                                    control={control}
                                    error={errors.pagaIva}
                                    disabled={isComplementario || isDesactivado}
                                />
                            </Grid2>
                        </Grid2>
                    </form>
                    <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                        {
                            !isComplementario ? (
                                <>
                                    <DetalleMutuoPermissionGuard
                                        esVigente={esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info]}>

                                        <MButton
                                            variant="contained"
                                            disabled={!(isDirty && isValid)}
                                            onClick={handleSubmit(onSubmit)}>
                                            Guardar
                                        </MButton>
                                    </DetalleMutuoPermissionGuard>
                                    <MButton variant="contained" onClick={handleCancelar}>
                                        Cancelar
                                    </MButton>
                                </>

                            ) : (
                                <MButton variant="contained" onClick={handleCancelar}>
                                    OK
                                </MButton>
                            )
                        }

                    </Grid2>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DatosGarantiaForm;